import { render, staticRenderFns } from "./add-inventory.vue?vue&type=template&id=5762b6cc&scoped=true&"
import script from "./add-inventory.vue?vue&type=script&lang=js&"
export * from "./add-inventory.vue?vue&type=script&lang=js&"
import style0 from "./add-inventory.vue?vue&type=style&index=0&id=5762b6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762b6cc",
  null
  
)

export default component.exports